import { z } from 'zod'

export const httpStatusCodeSchema = z.union([
  z.literal(400),
  z.literal(401),
  z.literal(403),
  z.literal(404),
  z.literal(405),
  z.literal(409),
  z.literal(422),
  z.literal(500)
])
export type HttpStatusCode = z.infer<typeof httpStatusCodeSchema>

export type HttpStatus = {
  BAD_REQUEST: 400
  NOT_AUTHORIZED: 401
  FORBIDDEN: 403
  NOT_FOUND: 404
  METHOD_NOT_ALLOWED: 405
  CONFLICT: 409
  UNPROCESSABLE: 422
  SERVER_ERROR: 500
}
